var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_30524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8094 8.14945C15.8094 7.49394 15.7562 7.01559 15.6411 6.51953H8.15576V9.47819H12.5495C12.4609 10.2135 11.9826 11.3208 10.9195 12.0648L10.9046 12.1639L13.2714 13.9973L13.4353 14.0137C14.9412 12.6229 15.8094 10.5766 15.8094 8.14945Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15583 15.945C10.3084 15.945 12.1155 15.2363 13.4354 14.0139L10.9196 12.065C10.2464 12.5345 9.34282 12.8623 8.15583 12.8623C6.04755 12.8623 4.25818 11.4716 3.62032 9.54932L3.52682 9.55726L1.06587 11.4618L1.03369 11.5513C2.34471 14.1556 5.03766 15.945 8.15583 15.945Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62011 9.54936C3.45181 9.0533 3.3544 8.52176 3.3544 7.97257C3.3544 7.42332 3.45181 6.89184 3.61126 6.39577L3.6068 6.29013L1.11501 4.35498L1.03349 4.39376C0.493151 5.47449 0.183105 6.68811 0.183105 7.97257C0.183105 9.25703 0.493151 10.4706 1.03349 11.5513L3.62011 9.54936Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15583 3.08269C9.65287 3.08269 10.6627 3.72934 11.2385 4.26974L13.4885 2.07285C12.1067 0.788397 10.3084 0 8.15583 0C5.03766 0 2.34471 1.78937 1.03369 4.39371L3.61146 6.39573C4.25818 4.47347 6.04755 3.08269 8.15583 3.08269Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_30524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.92fc90ac201567b3a4feda0060211355.svg";
export { ForwardRef as ReactComponent };